import { PaymentDirection } from '@cpce/database/enums';
import { createFileRoute } from '@tanstack/react-router';
import { PendingPaymentsPage } from '@/features/treasury/components/PendingPaymentsPage';

export const Route = createFileRoute('/$commiteeSlug/treasury/pending-disbursements')({
  component: () => <PendingPaymentsPage direction={PaymentDirection.outflow} dueByToday={false} />,
});
